export const POKEMON_GENERATIONS = {
  INITIAL: "https://pokeapi.co/api/v2/pokemon",
  GOLD_SILVER: "https://pokeapi.co/api/v2/pokemon?offset=151&limit=20",
  RUBY_SAPPHIRE: "https://pokeapi.co/api/v2/pokemon?offset=251&limit=20",
  DIAMOND_PEARL: "https://pokeapi.co/api/v2/pokemon?offset=386&limit=20",
  BLACK_WHITE: "https://pokeapi.co/api/v2/pokemon?offset=494&limit=20",
  XY: "https://pokeapi.co/api/v2/pokemon?offset=649&limit=20",
  SUN_MOON: "https://pokeapi.co/api/v2/pokemon?offset=721&limit=20",
  SWORD_SHIELD: "https://pokeapi.co/api/v2/pokemon?offset=809&limit=20",
  ARCEUS: "https://pokeapi.co/api/v2/pokemon?offset=898&limit=20",
  SCARLET_VIOLET: "https://pokeapi.co/api/v2/pokemon?offset=905&limit=20",
};
